import { store } from 'src/redux';
const colors = store.getState().theme.colors;

// Version A (current) — teal/green family: base (light) / live (vivid) / complete (deep).
// Version B (previous) — amber/orange family. Green vs orange is the Okabe-Ito colour-blind-safe
// pairing, and the wide lightness range per version keeps the "live" line the most prominent.
const col_a_live = colors.compareA; // #009E73
const col_a_base = '#7FD4B0';
const col_a_complete = '#005C44';

const col_b_live = colors.compareB; // #D55E00
const col_b_base = '#F2B279';
const col_b_complete = '#7A2E00';

export const plotColors = {
  col_a_live,
  col_a_base,
  col_a_complete,
  col_b_live,
  col_b_base,
  col_b_complete,
};
